var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollaborationColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "003-collaboration",
    clipPath: "url(#clip0_472_106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.3702 31.5802L53.1727 7.17284L43.3331 11.284C43.4566 10.1235 43.4566 8.48148 42.827 7.2963C41.4196 4.66667 38.1356 3.66667 35.506 5.07407C32.8764 6.48148 31.8764 9.76543 33.2838 12.3951C33.7776 13.321 34.5183 14.0741 35.4319 14.5802L24.9134 18.963C24.6788 18.2222 24.3208 17.5185 23.864 16.8889C23.9998 16.8148 24.1109 16.7284 24.222 16.6173C24.4813 16.358 24.6418 16.0123 24.6418 15.642L24.5924 11.5679H25.4319C25.6294 11.5679 25.8146 11.4815 25.9504 11.3457C26.0986 11.2099 26.1727 11.0123 26.1727 10.8148L26.0245 0L24.543 0.0246914L24.6788 10.0864L4.88871 10.2346L4.7529 0L3.27142 0.0246914L3.40723 11C3.41957 11.4074 3.74056 11.716 4.14797 11.7284H5.01216C5.01216 11.7654 5.06155 15.8025 5.06155 15.8025C5.07389 16.2469 5.29611 16.6543 5.65414 16.9136L5.11093 17.7778C4.90105 18.1111 4.6171 18.9383 4.6171 18.9383H4.60476L2.44426 27L3.01216 28.7531L2.20969 29.1111C1.46895 29.4444 0.876361 30.0494 0.59241 30.8148C0.30846 31.5802 0.333151 32.4198 0.666484 33.1605L11.6418 57.679L21.9257 53.0741C22.2961 52.9136 22.5554 52.5679 22.5924 52.1605C22.6294 51.7531 22.4443 51.358 22.1109 51.1358C20.7899 50.2099 19.8764 49.2099 19.6048 48.3951C18.9134 46.3457 20.0122 44.1111 22.0739 43.4198C24.1233 42.7284 26.3578 43.8272 27.0492 45.8889C27.3825 46.8642 27.3085 47.9383 26.8517 48.8642C26.6541 49.2593 26.7282 49.7284 27.0369 50.037C27.3332 50.358 27.8023 50.4568 28.1973 50.2716L36.7406 46.4444C37.148 46.2716 37.4936 45.9753 37.7406 45.6049L39.0369 45.0741C39.185 46.2963 39.6418 47.4568 40.3702 48.4568C40.2344 48.5309 40.1233 48.6296 40.0122 48.7407C39.7406 49 39.5924 49.358 39.5924 49.7284L39.6541 53.7901H38.8146C38.6171 53.7901 38.4319 53.8765 38.2961 54.0123C38.148 54.1481 38.0739 54.3457 38.0862 54.5432L38.222 63.8642H39.7035L39.5677 55.284L59.3578 55.1235L59.4936 63.8765H60.9751L60.8393 54.3827C60.827 53.9753 60.506 53.6543 60.0986 53.642H59.2344C59.2344 53.6173 59.2467 53.5802 59.2467 53.5556L59.185 49.5802C59.185 49.1358 58.9628 48.716 58.5924 48.4691C58.8764 48.0123 59.0986 47.6667 59.1356 47.5926C59.3455 47.2716 59.506 46.9136 59.6048 46.5309L59.6294 46.4444H59.6418L61.8023 38.3704L61.0122 35.8765L61.7282 35.5802C63.2838 34.9383 64.0245 33.1728 63.3825 31.6173C63.3825 31.6049 63.3702 31.5926 63.3702 31.5802ZM11.6541 24.8889L11.5307 25.0988C10.6912 26.5802 9.17266 27.2346 9.16031 27.2346L8.6171 27.4568C8.6171 27.4568 9.46895 32.6049 9.70352 34.0988C9.83932 34.9877 9.67883 35.9012 9.23439 36.679C8.9134 37.1358 8.39488 37.4074 7.83932 37.4074C7.45661 37.3951 7.29611 37.1975 7.23439 37.0864L4.82698 29.5679L4.37019 28.1481L3.98747 26.963L6.07389 19.1975C6.13562 18.9753 6.23439 18.7654 6.35784 18.5679C6.35784 18.5679 6.74056 17.9506 7.17266 17.284L22.185 17.1605C22.827 17.8395 23.2961 18.6667 23.5554 19.5679L11.6541 24.8889ZM22.8887 15.6914H22.864V15.6667L6.85167 15.7901C6.74056 15.8025 6.64179 15.7654 6.55537 15.7037V15.5556L6.50599 11.8272C6.59241 11.7778 6.69118 11.7407 6.78994 11.7407L22.827 11.6173C22.9381 11.6049 23.0369 11.642 23.1233 11.7037L23.185 15.6049C23.0986 15.6543 22.9875 15.6914 22.8887 15.6914ZM36.1356 45.0864L28.5677 48.4815C29.2961 45.5802 27.543 42.642 24.6418 41.9136C21.7406 41.1852 18.8023 42.9383 18.0739 45.8395C17.8146 46.8395 17.864 47.9012 18.185 48.8765C18.6048 50.0988 19.7282 51.1852 20.7529 51.9753L12.3702 55.7284L1.99982 32.5556C1.82698 32.1728 1.81463 31.7407 1.97513 31.3457C2.12327 30.9506 2.41957 30.642 2.80229 30.4691L3.45661 30.1728L5.87636 37.716C6.24673 38.4198 6.96278 38.8765 7.76525 38.8889C7.76525 38.8889 9.69118 38.9259 10.4813 37.4568V37.4321C11.0986 36.3457 11.3332 35.0864 11.1356 33.8519C10.9504 32.6667 10.4443 29.5679 10.2344 28.321C11.222 27.7778 12.0615 26.9877 12.6788 26.0494L25.2097 20.4321C25.2097 20.4321 25.5554 20.2346 25.827 20.2963C25.9875 20.358 26.1356 20.5432 26.2097 20.7037L30.0862 29.5679C30.2467 29.9753 30.6541 30.2222 31.0862 30.1975C31.5183 30.1728 31.8887 29.8765 32.0245 29.4691C32.3578 28.3457 33.1727 27.4444 34.2591 27C36.185 26.1358 38.4566 26.9877 39.3208 28.9136C40.1233 30.6914 39.469 32.7778 37.7899 33.7778C36.7159 34.3827 34.8393 34.2346 34.0862 34.1481C33.6912 34.0988 33.2961 34.2716 33.0492 34.5926C33.0492 34.6049 32.6912 35.0123 32.9257 35.716L36.5924 43.8889C36.7282 44.1975 36.6788 44.5679 36.469 44.8272C36.3949 44.9383 36.2714 45.037 36.1356 45.0864ZM57.7035 49.7901L57.7653 53.5185C57.6788 53.5802 57.5801 53.6173 57.469 53.6049L41.4319 53.7284C41.3208 53.7407 41.222 53.7037 41.1356 53.642L41.0739 49.8025L57.7035 49.7901ZM58.1727 46.1481C58.1109 46.3704 58.0122 46.5802 57.8887 46.7778V46.8025C57.8887 46.8025 57.5183 47.4074 57.0862 48.0741L56.9381 48.3086H42.185L42.0615 48.1852C41.1109 47.1728 40.543 45.8519 40.469 44.4568L51.1603 40C50.9257 40.4198 50.7035 40.8642 50.4936 41.3086L51.8393 41.9383C52.1109 41.358 52.4072 40.7901 52.7159 40.2469C53.0245 39.7037 53.4443 39.2346 53.9257 38.8395C54.2838 38.5432 54.6665 38.3086 55.0862 38.1111L55.6294 37.8889L55.543 37.3086C55.5307 37.2963 55.4936 37.0247 55.4196 36.6173C55.1973 35.284 54.7282 32.3951 54.543 31.2593C54.4072 30.3704 54.5677 29.4568 55.0122 28.679C55.3331 28.2222 55.8517 27.9383 56.4072 27.9383C56.7899 27.9506 56.9504 28.1481 57.0122 28.2716L59.185 35.037L59.6418 36.4568L60.2591 38.3951L58.1727 46.1481ZM62.0122 33.358C61.8517 33.7407 61.543 34.0494 61.1603 34.2099L60.5554 34.4691L58.3578 27.6296C57.9875 26.9259 57.2714 26.4815 56.4813 26.4568C54.5801 26.5062 53.7529 27.9012 53.7529 27.9012C53.1356 28.9877 52.9011 30.2469 53.0986 31.4815C53.2838 32.679 53.7899 35.7654 53.9998 37.0123C53.7159 37.1728 53.4443 37.358 53.185 37.5556L38.1233 43.8519C38.0862 43.6543 34.6541 35.9259 34.6541 35.9259C35.8764 36.0123 37.2838 35.9506 38.3331 35.3951L38.8023 35.1111C39.3702 34.7284 39.864 34.2469 40.2467 33.679L40.4072 33.4321C40.6912 32.963 40.9011 32.4568 41.0369 31.9259C41.0492 31.9012 41.0492 31.8765 41.0492 31.8519H41.0615C41.1973 31.3704 41.2591 30.8765 41.2591 30.3704C41.2591 29.8272 41.1727 29.2716 41.0122 28.7531C40.1233 25.9012 37.0862 24.321 34.2344 25.2099C32.864 25.642 31.7159 26.6049 31.0492 27.8889L30.1727 25.9259C29.8887 25.2222 27.9998 21.0741 27.5801 20.1111C27.4813 19.9259 27.3702 19.7407 27.2344 19.5802L36.9998 15.5556C37.4072 15.3827 37.6541 14.9753 37.6294 14.5432C37.6171 14.1111 37.3208 13.7407 36.9134 13.6173C34.8393 12.9877 33.6665 10.8025 34.2961 8.71605C34.3578 8.51852 34.4319 8.33333 34.5183 8.14815C34.9998 7.1358 35.8887 6.37037 36.9751 6.07407C38.7529 5.5679 40.6418 6.35802 41.5183 7.98765C42.0986 9.07407 41.9011 10.9383 41.7899 11.6914C41.7406 12.0988 41.9011 12.4938 42.222 12.7407C42.543 12.9877 42.9628 13.0494 43.3331 12.8889L52.3702 9.11111L61.9998 32.1481C62.1727 32.5309 62.1727 32.9753 62.0122 33.358Z",
    fill: "url(#paint0_linear_472_106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.9732 58.013L15.6567 58.6924L17.3666 62.0054L18.683 61.326L16.9732 58.013Z",
    fill: "url(#paint1_linear_472_106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.68006 58.0726L4.97021 61.3857L6.28666 62.0651L7.9965 58.752L6.68006 58.0726Z",
    fill: "url(#paint2_linear_472_106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.1023 60.1945L11.0112 63.9218L12.4923 63.958L12.5834 60.2307L11.1023 60.1945Z",
    fill: "url(#paint3_linear_472_106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M48.295 2.09104L46.9785 2.77045L48.6884 6.0835L50.0048 5.40409L48.295 2.09104Z",
    fill: "url(#paint4_linear_472_106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M59.3788 2.14081L57.6689 5.45386L58.9854 6.13326L60.6952 2.82022L59.3788 2.14081Z",
    fill: "url(#paint5_linear_472_106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M53.0872 0.160234L52.9961 3.88751L54.4771 3.92371L54.5682 0.19643L53.0872 0.160234Z",
    fill: "url(#paint6_linear_472_106)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_472_106",
    x1: 4.57516,
    y1: 7.66697,
    x2: 43.8177,
    y2: 83.6709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_472_106",
    x1: 15.949,
    y1: 59.0451,
    x2: 19.3395,
    y2: 59.6779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_472_106",
    x1: 5.24125,
    y1: 61.2482,
    x2: 7.34632,
    y2: 61.8447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_472_106",
    x1: 11.195,
    y1: 63.6798,
    x2: 13.3493,
    y2: 63.2969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_472_106",
    x1: 47.2708,
    y1: 3.1232,
    x2: 50.6613,
    y2: 3.75593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_472_106",
    x1: 57.94,
    y1: 5.31641,
    x2: 60.045,
    y2: 5.9129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_472_106",
    x1: 53.1799,
    y1: 3.64548,
    x2: 55.3342,
    y2: 3.26262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborationColor);
export default __webpack_public_path__ + "static/media/collaborationColor.9368bc7a1e1e19441c025b64186c2bbd.svg";
export { ForwardRef as ReactComponent };